import { EntityType, ILink, IPoint } from "@multiweb/picasso";
import { bridge } from "@multiweb/reactCore/bridge";
import { Transition } from "./workflowModel";

const { generateUUID } = bridge;

export class UiTransition implements ILink {
    public readonly id: string;
    public readonly index: number;
    public readonly type: EntityType;
    public readonly name: string;
    public readonly ownerIndex: number;
    public readonly startComponentIndex: number;
    public readonly endComponentIndex: number;
    public readonly transition: Transition;
    public readonly points: readonly IPoint[];

    constructor(index: number, points: readonly IPoint[], startComponentIndex: number, endComponentIndex: number, transition: Transition) {
        this.id = generateUUID();
        this.index = index;
        this.type = EntityType.link;
        this.name = "Transition";
        this.ownerIndex = 0;
        this.startComponentIndex = startComponentIndex;
        this.endComponentIndex = endComponentIndex;
        this.transition = transition;
        this.points = points;

        this.transition.points = [];
        points.forEach(point => {
            this.transition.points.push({ x: point.x, y: point.y });
        });
    }
}
